export default __webpack_public_path__ + "static/media/al_contactus.f38b70e7.png";